import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  return <a href="https://estrategiaveloz.com/cart/52075305828645:1" onClick={onClick} className={`
        inline-block text-center cursor-pointer
        bg-brand-orange text-white font-oswald font-bold text-xl md:text-2xl uppercase 
        py-4 px-8 rounded-md transition-all transform hover:-translate-y-1 
        animate-pulse-glow hover:bg-[#ff7b4a] active:translate-y-0
        ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
        ${className}
      `} data-id="element-1">
      {children}
    </a>;
}